import { Dialog as DialogPrimitive } from "radix-ui";

interface DialogCloseProps {
  children: React.ReactNode;
  className?: string;
}

function DialogClose({ children, className }: DialogCloseProps) {
  return <DialogPrimitive.Close className={className}>{children}</DialogPrimitive.Close>;
}

export { DialogClose };
